var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: ', ';\n  list-style: none;\n  position: relative;\n  box-sizing: border-box;\n  margin-bottom: 16px;\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  list-style: none;\n  position: relative;\n  box-sizing: border-box;\n  margin-bottom: 16px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: row;\n  justify-content: space-around;\n'], ['\n  display: flex;\n  flex-flow: row;\n  justify-content: space-around;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: auto;\n  border: none;\n  padding: 0.5em;\n  margin: 0.2em;\n  text-align: center;\n  font-weight: 100;\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 1px 5px 0 rgba(32, 24, 73, 0.39);\n  background-color: ', ';\n  color: #fff;\n'], ['\n  width: 100%;\n  height: auto;\n  border: none;\n  padding: 0.5em;\n  margin: 0.2em;\n  text-align: center;\n  font-weight: 100;\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 1px 5px 0 rgba(32, 24, 73, 0.39);\n  background-color: ', ';\n  color: #fff;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import Avatar from './avatar.js';
import Arrow from './arrow.js';
import Bubble from './bubble.js';

var ListItem = styled.li(_templateObject, function (props) {
  return props.user === 'CUSTOMER' ? 'row-reverse' : 'row';
});

var ActionContainer = styled.div(_templateObject2);

var Button = function Button(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      text = _ref.text;
  return React.createElement(
    'button',
    { className: className, onClick: onClick },
    text
  );
};

var StyledButton = styled(Button)(_templateObject3, function (props) {
  return props.theme.color;
});

var Message = function Message(_ref2) {
  var message = _ref2.message,
      index = _ref2.index;

  var componentProps = void 0;
  if (message.component) {
    componentProps = _extends({}, message.component.props);
    Object.keys(componentProps).forEach(function (prop) {
      return componentProps[prop] = componentProps[prop]();
    });
  }

  return React.createElement(
    ListItem,
    { user: message.user, id: '__message-' + index },
    React.createElement(Avatar, { user: message.user }),
    React.createElement(Arrow, { user: message.user }),
    React.createElement(
      Bubble,
      { message: message },
      message.actions && React.createElement(
        ActionContainer,
        null,
        message.actions.map(function (action, i, arr) {
          return React.createElement(StyledButton, _extends({ key: i, count: arr.length }, action));
        })
      ),
      message.component && React.createElement(message.component.type, componentProps)
    )
  );
};

export default Message;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/message-list/message/index.js
// module id = 761
// module chunks = 1